import { ReactNativeProps } from '@eika-infrastruktur/mobilbank-lib';
import { AppleWallet } from '@eika-infrastruktur/mobilbank-lib/src/nativeProps';

import {
    ApplePayEligibleCard,
    ApplePayToken,
    ApplePayTokenStatus,
    ApplePayTokenType,
    CardVendor,
    DeviceType,
} from '@generated-types';

const mockedNativePropAppleWallet: AppleWallet = {
    localPasses: [
        { value: 'V-3256749422578649467411' },
        { value: 'V-3256749422578649467414' },
        { value: 'V-3256749422578649467415' },
    ],
    hasAvailableCardsForLocalOnboarding: true,
    pendingCardTokens: [
        {
            primaryAccountIdentifier: { value: 'V-3256749422578649467411' },
            tokenUniqueReference: { value: '1234' },
            isRemotePass: false,
        },
        {
            primaryAccountIdentifier: { value: 'V-325674942257864946741' },
            tokenUniqueReference: { value: '2345' },
            isRemotePass: false,
        },
        {
            primaryAccountIdentifier: { value: 'V-3256749422578649467421' },
            tokenUniqueReference: { value: '3456' },
            isRemotePass: true,
        },
        {
            primaryAccountIdentifier: { value: 'V-325674942257864946121' },
            tokenUniqueReference: { value: '4567' },
            isRemotePass: true,
        },
    ],
    remotePasses: [],
    isWatchPaired: false,
};

export const mockedReactNativeProps: ReactNativeProps = {
    platform: 'ios',
    safeAreaInsets: { top: 0, bottom: 0, left: 0, right: 0 },
    appVersion: '2.0.0',
    deviceId: '1234',
    supportsEvent: { openPdf: true, refreshApplePayProps: true, switchBank: true },
    supports: {
        showLastLoginToasterInWeb: true,
        cookies: true,
        applePay: true,
        changeAppIcon: true,
        googleWallet: true,
        idScanAndroid11plus: true,
        loginAndSigningMethod: true,
        stepUpAuth: true,
        pushNotificationsV2: true,
    },
    ReactNativePropsVersion: 2,
    thirdPartyDependencies: {},
    thirdPartyDependenciesV2: [],
    bankRelationships: [],
    biometrics: {
        biometricsEnabledApp: true,
        biometricsEnabledOS: true,
        biometricCapabilities: { type: 'faceID', status: 'enrolled' },
    },
    deviceInfo: {
        systemName: '',
        deviceId: '',
        systemVersion: '17.0.0',
        firstInstallTime: undefined,
        brand: 'apple',
        lastUpdateTime: undefined,
        apiLevel: undefined,
        userAgent: '',
        model: '',
    },
    downloadUrl: '',
    loginMethod: { error: false, type: 'BIOMETRIC' },
    signingMethod: { type: 'BIOMETRIC', error: false },
    pushEnabledOS: true,
    appleWallet: mockedNativePropAppleWallet,
};

export const createAppleWalletNativeProps = (otherProps: Partial<AppleWallet> = {}): ReactNativeProps => ({
    ...mockedReactNativeProps,
    appleWallet: { ...mockedNativePropAppleWallet, ...otherProps },
});

export const createNativeProps = (otherProps: Partial<ReactNativeProps> = {}) => ({
    ...mockedReactNativeProps,
    ...otherProps,
});

export const createDigitalCard = (otherProps: Partial<ApplePayEligibleCard> = {}): ApplePayEligibleCard => ({
    title: '1234',
    cardVendor: CardVendor.VISA,
    customerName: 'Test test',
    tokens: [],
    cardLast4Digits: '0234',
    eikaCardId: '123456789',
    imageName: '9812_1234x',
    ...otherProps,
});

export const createToken = (otherProps: Partial<ApplePayToken> = {}): ApplePayToken => ({
    tokenType: ApplePayTokenType.REMOTE,
    panUniqueReference: '123456787654',
    deviceType: DeviceType.MOBILE_PHONE,
    status: ApplePayTokenStatus.ACTIVE,
    ...otherProps,
});
